import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgArrowRightCircle = function SvgArrowRightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12ZM12.5 3.5C7.80558 3.5 4 7.30558 4 12C4 16.6944 7.80558 20.5 12.5 20.5C17.1944 20.5 21 16.6944 21 12C21 7.30558 17.1944 3.5 12.5 3.5ZM12.6304 8.1661C12.9233 7.87321 13.3982 7.87321 13.691 8.1661L16.9946 11.4697C17.2875 11.7626 17.2875 12.2374 16.9946 12.5303L13.691 15.8339C13.3982 16.1268 12.9233 16.1268 12.6304 15.8339C12.3375 15.541 12.3375 15.0661 12.6304 14.7732L14.6536 12.75H8.53571C8.1215 12.75 7.78571 12.4142 7.78571 12C7.78571 11.5858 8.1215 11.25 8.53571 11.25H14.6536L12.6304 9.22676C12.3375 8.93387 12.3375 8.45899 12.6304 8.1661Z"
  })));
};

export { SvgArrowRightCircle as ReactComponent };
//# sourceMappingURL=arrow-right-circle.svg.js.map
